import { lazy } from "react";

const MAX_RETRIES = 3;
const RETRY_DELAY = 500;
let hasReloaded = false;

function retryImport(factory, retries = MAX_RETRIES) {
  return new Promise((resolve, reject) => {
    factory()
      .then(resolve)
      .catch(error => {
        if (retries > 0) {
          setTimeout(() => {
            retryImport(factory, retries - 1).then(resolve, reject);
          }, RETRY_DELAY);
        } else if (!hasReloaded) {
          hasReloaded = true;
          window.location.reload();
        } else {
          reject(error);
        }
      });
  });
}

export function lazyWithPreload(factory) {
  const Component = lazy(() => retryImport(factory));
  Component.preload = () => retryImport(factory);
  return Component;
}
